module.exports = __webpack_public_path__ + "static/media/earth_atmos_2048.e15eb8d2.jpg";